<template>
  <v-dialog v-model="dialogLocal" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Edit stage</span>
      </v-card-title>
      <v-card-text>
        <vue-form :state="editStage" @submit.prevent="saveChanges">
          <v-container class="pt-0" fluid grid-list-xl>
            <v-layout wrap align-top justify-end>
              <v-btn color="warning" flat @click="close">
                Close
              </v-btn>
              <v-btn type="submit" color="success">
                Save
              </v-btn>
            </v-layout>
          </v-container>
          <v-container class="pt-0" grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <validate>
                  <async-autocomplete
                    v-model="data.steps"
                    :items="stepsForStage"
                    name="steps"
                    label="Select steps"
                    item-text="name"
                    item-value="id"
                    return-object
                    multiple
                    required
                  />
                  <field-messages
                    name="steps"
                    show="$dirty && $touched || $submitted"
                  >
                    <small class="error--text" slot="required">
                      Steps is a
                      required field
                    </small>
                  </field-messages>
                </validate>
              </v-flex>
            </v-layout>
          </v-container>

        </vue-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import ProcessSteps from '@/orm/models/ProcessSteps';
import asyncAutocomplete from '@/components/form/asyncAutocomplete';

export default {
  name: 'editProcessStagePopup',
  props: {
    dialog: Boolean,
    stage: Object,
    steps: Array,
  },
  data() {
    return {
      data: {
        steps: JSON.parse(JSON.stringify(this.steps)),
      },
      stepsOrmModel: ProcessSteps,
      editStage: {},
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.data.steps = JSON.parse(JSON.stringify(this.steps));
      }
    },
  },
  computed: {
    dialogLocal: {
      get() {
        return this.dialog;
      },
      set(val) {
        this.$emit('update:dialog', val);
      },
    },
    stepsForStage() {
      let stageId = this.stage && this.stage.id > 0 ? this.stage.id : 0;
      return ProcessSteps.all().filter(step => step.stages.includes(stageId));
    },
  },
  methods: {
    close() {
      this.editStage._reset();
      this.dialogLocal = false;
    },
    saveChanges() {
      if (!this.editStage.$valid) {
        return;
      }
      this.$emit('update', this.data.steps);
      this.close();
    },
  },
  components: {
    asyncAutocomplete,
  },
};
</script>
